import useSWR from "swr";

import { dataFetcher } from "../model/dataFetcher";

export type DailyStatisticType = {
    trades_daily_started: number;
    trades_daily_finished: number;
    trades_daily_cancelled: number;
    transactions_daily: number;
    new_users_daily: number;
    dispute_queue_size: number;
    dispute_growth: number; // percentage
    dispute_response_time: number; // seconds
    dispute_gc_resolution_time: number; // seconds
    dispute_ngc_resolution_time: number; // seconds
};

export const useDailyStatistic = () => {
    const { data, error, isLoading } = useSWR<DailyStatisticType>("/operational", dataFetcher, {
        refreshInterval: 6000,
    });

    return { data, error, isLoading };
};
